// Renders text with any embedded Linear ticket IDs (like ENG-1234) turned
// into external links to linear.app/squint/issue/{id}.
//
// Matches the same regex the LLM extractor uses to *find* tickets, so what
// gets structured into linear_ticket_ids and what gets inline-linked stay
// in sync.
import React from "react";

const TICKET_RE = /\b[A-Z]{2,10}-\d+\b/g;

export function renderTextWithLinearLinks(text: string): React.ReactNode[] {
  const out: React.ReactNode[] = [];
  let lastIdx = 0;
  let key = 0;
  for (const m of text.matchAll(TICKET_RE)) {
    const start = m.index ?? 0;
    if (start > lastIdx) out.push(text.slice(lastIdx, start));
    const ticket = m[0];
    out.push(
      <a
        key={key++}
        href={`https://linear.app/squint/issue/${ticket}`}
        target="_blank"
        rel="noopener noreferrer"
        className="content-link"
      >
        {ticket}
      </a>,
    );
    lastIdx = start + ticket.length;
  }
  if (lastIdx < text.length) out.push(text.slice(lastIdx));
  return out;
}
